import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Input, Button, Icon } from "semantic-ui-react";
import { auth, googleAuthProvider } from "../../firebase";
import { toast } from "react-toastify";
import { Dimmer, Loader } from "semantic-ui-react";
import { createUpdateUser } from "../../helpers/auth";
import Layout from "../../hoc/Layout";
import { Link } from "react-router-dom";

const Login = ({ history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const roleBasedRedirect = (res) => {
    console.log("In Log In");
    if (res.payload.role === "admin") {
      history.push("/admin/dashboard");
    } else {
      history.push("/user/dashboard");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await auth.signInWithEmailAndPassword(email, password);
      // console.log(result);
      const { user } = await result;
      const idTokenResult = await user.getIdTokenResult();
      createUpdateUser(idTokenResult.token)
        .then((res) =>
          dispatch({
            type: "LOGGED_IN_USER",
            payload: {
              picture: res.data.picture,
              email: res.data.email,
              token: idTokenResult.token,
              role: res.data.role,
              _id: res.data._id,
            },
          })
        )
        .then((res) => {
          window.localStorage.setItem("token", idTokenResult.token);
          roleBasedRedirect(res);
        })
        .catch((error) => console.error(error));

      // history.push("/");
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  const googleLogin = async () => {
    auth
      .signInWithPopup(googleAuthProvider)
      .then(async (result) => {
        const { user } = result;
        const idTokenResult = await user.getIdTokenResult();
        createUpdateUser(idTokenResult.token)
          .then((res) =>
            dispatch({
              type: "LOGGED_IN_USER",
              payload: {
                picture: res.data.picture,
                email: res.data.email,
                token: idTokenResult.token,
                role: res.data.role,
                _id: res.data._id,
              },
            })
          )
          .then((res) => {
            // console.log("Role", res.payload.role);
            window.localStorage.setItem("token", idTokenResult.token);
            roleBasedRedirect(res);
          })
          .catch((error) => console.error(error));
        // history.push("/");
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      });
  };

  const loginForm = () => (
    <form onSubmit={handleSubmit} className="mainForm">
      <Input
        type="email"
        className="regInput"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoFocus
        placeholder="email"
      />
      <Input
        type="password"
        className="regInput"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
      />
      <br />
      <Button
        type="submit"
        basic
        color="purple"
        disabled={!email || password.length < 6}
      >
        Login
      </Button>
    </form>
  );

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="ui container ">
          <div className="regForm">
            {loading ? (
              <>
                <Dimmer active inverted>
                  <Loader size="massive">Loading</Loader>
                </Dimmer>
              </>
            ) : (
              <>
                {" "}
                <h2 className="subTitle">Log-in</h2>
                <h3 className="subTitle">
                  To change the world as we know it
                </h3>{" "}
              </>
            )}

            {loginForm()}
            <Link to="/forgot/password" className="forgot">
              Forgot Password?
            </Link>
          </div>
          <div className="mainForm regForm">
            <Button
              onClick={googleLogin}
              className="gbutton"
              color="google plus"
            >
              <Icon name="google plus" /> Google Login
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
